import {ActiveRecord} from './ActiveRecord';
import config from 'config';

import { ListItemImage } from './club-cms/content';
import { ImageListItemImage } from './club-cms/content/image-list.content';
import { GalleryContentItem } from './club-cms/content/gallery.content';
import { grabImages } from './club-cms/image-graber';


const IMAGE_LIST_ITEM_REF = 'studious';
const GALLERY_ITEM_REF = 'gallery';


const CONTENT_PARAM = 'events'

export default class CityEvents extends ActiveRecord {
  static path = `${config.backOfficeBasePath}/application_content`;
  
  club_id = '';

  _getModel() {
    return CityEvents;
  }


  async saveModels(items, ref_data) {
    if (items.length > 0) {
      let requestData = {
        ref_data,
      };

      items.forEach((image, index) => requestData['file' + index] = image.file);


      let responses = await this._networkLayer.postFormData(`/backoffice/clubs/${this.club_id}/photos`, requestData);

      let data = await responses.json();

      items.forEach((item, index) => item.setOriginal(data[index]));

      return items;
    }
  }

  async saveImages(info) {
    let newImages = grabImages(info.items.toArray());
    let listImages = newImages.filter(item => item instanceof ListItemImage);
    let imageListImages = newImages.filter(item => item instanceof ImageListItemImage);
    let galleryImages = newImages.filter(item => item instanceof GalleryContentItem);

    let saveImagePromise  = Promise.all([
      this.saveModels(listImages, IMAGE_LIST_ITEM_REF),
      this.saveModels(imageListImages, IMAGE_LIST_ITEM_REF),
      this.saveModels(galleryImages, GALLERY_ITEM_REF)
    ]);

    return await saveImagePromise;
  }

  fetch() {
    return this._networkLayer.getJson(this._prepareUrl(CONTENT_PARAM))
      .then((result) => result.info || []);
  }

  save(data) {
    return this._networkLayer.putJson(this._prepareUrl(CONTENT_PARAM), {info: data, id: 'events', name: 'events', time_zone: ''});
  }
}



// WEBPACK FOOTER //
// ./src/api/city_events.js